export const COMPANY_BASE_QUERY_KEY = 'company';

export const companyApiQueryKeys = {
  companySlug: () => [COMPANY_BASE_QUERY_KEY, 'slug'] as const,
  companyInfo: () => [COMPANY_BASE_QUERY_KEY, 'info'] as const,
  companyTimezone: () => [COMPANY_BASE_QUERY_KEY, 'timezone'] as const,
};
